/**
 * Stable string codes used on every API error response. The frontend maps each one to an
 * `errors.<code>` i18n key. Extended stage-by-stage as new failure modes are introduced —
 * this is the baseline set needed from stage 0 onward.
 */
export const ErrorCode = {
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  BAD_REQUEST: 'BAD_REQUEST',
  UNAUTHORIZED: 'UNAUTHORIZED',
  FORBIDDEN: 'FORBIDDEN',
  FORBIDDEN_ROLE: 'FORBIDDEN_ROLE',
  NOT_FOUND: 'NOT_FOUND',
  CONFLICT: 'CONFLICT',
  VERSION_CONFLICT: 'VERSION_CONFLICT',
  UNPROCESSABLE_ENTITY: 'UNPROCESSABLE_ENTITY',
  TOO_MANY_REQUESTS: 'TOO_MANY_REQUESTS',
  INTERNAL_ERROR: 'INTERNAL_ERROR',
  STORE_HEADER_REQUIRED: 'STORE_HEADER_REQUIRED',
  MEMBERSHIP_NOT_APPROVED: 'MEMBERSHIP_NOT_APPROVED',
  OWNER_CANNOT_DELETE_ACCOUNT: 'OWNER_CANNOT_DELETE_ACCOUNT',
  NO_CATEGORIES: 'NO_CATEGORIES',
  CATEGORY_REQUIRED: 'CATEGORY_REQUIRED',
  CATEGORY_HAS_CHILDREN: 'CATEGORY_HAS_CHILDREN',
  CATEGORY_HAS_PRODUCTS: 'CATEGORY_HAS_PRODUCTS',
  CATEGORY_IS_ROOT: 'CATEGORY_IS_ROOT',
  SUPPLIER_REQUIRED: 'SUPPLIER_REQUIRED',
  SUPPLIER_HAS_PRODUCTS: 'SUPPLIER_HAS_PRODUCTS',
  SUPPLIER_IN_USE: 'SUPPLIER_IN_USE',
  PRODUCT_IS_DRAFT: 'PRODUCT_IS_DRAFT',
  PRODUCT_NOT_DRAFT: 'PRODUCT_NOT_DRAFT',
  PURCHASE_SUPPLIER_REQUIRED: 'PURCHASE_SUPPLIER_REQUIRED',
  PURCHASE_NOT_POSTED: 'PURCHASE_NOT_POSTED',
  PURCHASE_EXISTS: 'PURCHASE_EXISTS',
  PURCHASE_NO_RECEIPT: 'PURCHASE_NO_RECEIPT',
  PAYMENT_EXCEEDS_DEBT: 'PAYMENT_EXCEEDS_DEBT',
  PAYMENT_ALREADY_VOIDED: 'PAYMENT_ALREADY_VOIDED',
  ORDER_HAS_PAYMENTS: 'ORDER_HAS_PAYMENTS',
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  FILE_TOO_LARGE: 'FILE_TOO_LARGE',
  IDEMPOTENCY_MISMATCH: 'IDEMPOTENCY_MISMATCH',
  INSUFFICIENT_STOCK: 'INSUFFICIENT_STOCK',
  LOCK_TIMEOUT: 'LOCK_TIMEOUT',
  STORE_CODE_NOT_FOUND: 'STORE_CODE_NOT_FOUND',
  CANNOT_JOIN_OWN_STORE: 'CANNOT_JOIN_OWN_STORE',
  JOIN_REQUEST_PENDING: 'JOIN_REQUEST_PENDING',
  ALREADY_CONNECTED: 'ALREADY_CONNECTED',
  CLIENT_BLOCKED: 'CLIENT_BLOCKED',
  CLIENT_NOT_APPROVED: 'CLIENT_NOT_APPROVED',
  ORDER_EMPTY: 'ORDER_EMPTY',
  PRODUCT_NOT_ORDERABLE: 'PRODUCT_NOT_ORDERABLE',
  ORDER_INVALID_TRANSITION: 'ORDER_INVALID_TRANSITION',
  ORDER_CANCELLED: 'ORDER_CANCELLED',
  INVALID_PERIOD: 'INVALID_PERIOD',
} as const;

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode];
